import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand navbar-light navbar-bg" }
const _hoisted_2 = { class: "navbar-collapse collapse" }
const _hoisted_3 = { class: "navbar-nav navbar-align align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "nav-item me-3"
}
const _hoisted_5 = { class: "nav-icon pe-md-0 dropdown-toggle position-relative" }
const _hoisted_6 = {
  class: "badge bg-danger rounded-pill position-absolute translate-middle",
  style: {"top":"-4px","right":"-8px","font-size":"10px"}
}
const _hoisted_7 = {
  class: "dropdown-item text-wrap",
  style: {"max-width":"320px"}
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "dropdown-item" }
const _hoisted_11 = {
  key: 1,
  class: "nav-item me-3"
}
const _hoisted_12 = {
  key: 0,
  class: "notification-bell__badge"
}
const _hoisted_13 = { class: "notification-list" }
const _hoisted_14 = { class: "fw-bold mb-1" }
const _hoisted_15 = { class: "small text-muted mb-2" }
const _hoisted_16 = ["href", "download"]
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = { class: "nav-icon pe-md-0 dropdown-toggle" }
const _hoisted_20 = { class: "ms-3 fw-bolder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dropdown_ui = _resolveComponent("dropdown-ui")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", {
      class: "sidebar-toggle cursor-pointer",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeSidebar && _ctx.changeSidebar(...args)))
    }, _cache[3] || (_cache[3] = [
      _createElementVNode("i", { class: "hamburger align-self-center" }, null, -1)
    ])),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (false && _ctx.$user.isUser && _ctx.pendingPassingsCount > 0)
          ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
              _createVNode(_component_dropdown_ui, null, {
                button: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_vue_feather, {
                      type: "bell",
                      size: "18"
                    }),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.pendingPassingsCount), 1)
                  ])
                ]),
                list: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[4] || (_cache[4] = _createTextVNode(" Чтобы считалось время проживания: ")),
                    (_ctx.hasPendingWrongDorm)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, " поменяйте общежитие студента — сейчас он приписан к другому общежитию."))
                      : _createCommentVNode("", true),
                    (_ctx.hasPendingNotFound)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Если студент не найден — добавьте студента."))
                      : _createCommentVNode("", true),
                    _cache[5] || (_cache[5] = _createTextVNode(" Затем учтите проход на странице «Ожидающие проходы». "))
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_router_link, {
                      to: "/pending-passings",
                      class: "btn btn-sm btn-primary"
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode("Перейти к ожидающим проходам")
                      ])),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.$user.isUser && _ctx.notificationItems.length)
          ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
              _createVNode(_component_dropdown_ui, null, {
                button: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "nav-icon pe-md-0 position-relative notification-bell",
                    title: "Уведомления",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.markAllNotificationsRead && _ctx.markAllNotificationsRead(...args)))
                  }, [
                    _createVNode(_component_vue_feather, {
                      type: "bell",
                      size: "18"
                    }),
                    (_ctx.notificationsUnreadCount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.notificationsUnreadCount), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                list: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationItems, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.key,
                        class: "notification-item"
                      }, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(item.title), 1),
                        _createElementVNode("div", _hoisted_15, _toDisplayString(item.message), 1),
                        (item.action && item.action.type === 'download')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "btn btn-sm btn-primary",
                              href: item.action.url,
                              download: item.action.fileName,
                              target: "_blank",
                              rel: "noopener"
                            }, _toDisplayString(item.action.label), 9, _hoisted_16))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_17, [
          _createVNode(_component_dropdown_ui, null, {
            button: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", {
                    class: "rounded-circle rounded ava d-flex justify-content-center align-items-center",
                    style: _normalizeStyle('background-color: ' + _ctx.$user.fill)
                  }, [
                    _createVNode(_component_vue_feather, {
                      size: "16",
                      style: _normalizeStyle('color: ' + _ctx.$user.color),
                      type: "user"
                    }, null, 8, ["style"])
                  ], 4)
                ]),
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$user.firstName), 1)
              ])
            ]),
            list: _withCtx(() => [
              _createElementVNode("div", {
                class: "dropdown-item cursor-pointer",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
              }, " Выход ")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}